class AuraDropdown {

  constructor(element) {

    this.element = element;

    this.trigger = element.querySelector('.aura-dropdown__trigger');
    this.menu = element.querySelector('.aura-dropdown__menu');

    if (!this.trigger || !this.menu) return;

    this.bindEvents();

  }

  bindEvents() {

    this.trigger.addEventListener(
      'click',
      this.toggle.bind(this)
    );

    document.addEventListener(
      'click',
      this.handleOutsideClick.bind(this)
    );

    document.addEventListener(
      'keydown',
      this.handleEscape.bind(this)
    );

  }

  open() {

    document
      .querySelectorAll('.aura-dropdown.is-open')
      .forEach(dropdown => {

        if (dropdown !== this.element) {

          dropdown.auraDropdown?.close();

        }

      });

    this.element.classList.add('is-open');

    this.trigger.setAttribute(
      'aria-expanded',
      'true'
    );

    this.menu.hidden = false;

  }

  close() {

    this.element.classList.remove('is-open');

    this.trigger.setAttribute(
      'aria-expanded',
      'false'
    );

    this.menu.hidden = true;

  }

  toggle(event) {

    event.stopPropagation();

    if (this.element.classList.contains('is-open')) {

      this.close();

    } else {

      this.open();

    }

  }

  handleOutsideClick(event) {

    if (!this.element.contains(event.target)) {

      this.close();

    }

  }

  handleEscape(event) {

    if (event.key === 'Escape') {

      this.close();

    }

  }

}

document.addEventListener('DOMContentLoaded', () => {

  document
    .querySelectorAll('.aura-dropdown')
    .forEach(element => {

      element.auraDropdown = new AuraDropdown(element);

    });

});